import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Course } from '../models';
import { PaginationParams } from '../types';

export const coursesActions = createActionGroup({
    source: 'Courses',
    events: {
        'Get Courses': props<{ value: PaginationParams }>(),
        'Get Courses Success': props<{ payload: Course[]; total: number }>(),
        'Get Courses Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
